import { InitiateKycResult } from "@bbb/model";
import { _apiRequest } from "./_apiClients";

export function initiateKyc(token?: string) {
  return _apiRequest<InitiateKycResult>("/v1/kyc/initiate", {
    method: "POST",
    token,
  });
}
